import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectImpersonationCandidatesRetrieval = createSelector(
  [(state: AppState) => state.admin.impersonationCandidatesRetrieval],
  ({ data, fetching }) => ({
    data,
    fetching,
  }),
);
